<div class="card mt-4">
  <div class="card-header">
    <h4 class="card-title">Customer Journey</h4>
  </div>
  <div class="card-body" style="height: 100vh">
    <span *ngIf="loading"> Loading... </span>
    <div *ngIf="!loading">{{ formatDuration() }}</div>
    <div *ngIf="!loading && settings.subtitle">{{ settings.subtitle }}</div>
    <svg *ngIf="!loading" width="100%" height="100%" viewBox="0 150 2048 1024" #transitionGraph>
      <g *ngFor="let v of vertices" class="node-container" [class.active]="hover == v" [class.inactive]="hover != null && hover != v">
        <g *ngFor="let t of v.targets" class="link">
          <path
            *ngIf="v.feature != t.feature"
            [id]="v.feature + '-' + t.feature"
            [attr.d]="t.path"
            stroke="black"
            stroke-width="1.25"
            fill="transparent"
            [attr.opacity]="0.2 + t.weight"
          />

          <text [attr.opacity]=" 0.2 + t.weight">
            <textPath [attr.xlink:href]="'#'+ v.feature + '-' + t.feature" startOffset="35%">
              {{ (t.weight * 100) | number:'1.0-1' }}%
            </textPath>
          </text>
        </g>
      </g>

      <g *ngFor="let v of vertices" class="node-container">
        <g class="node" [attr.transform]="'translate(' + v.xpos + ',' + v.ypos + ')'" (mouseenter)="hover = v" (mouseleave)="hover = null">
          <circle fill="#1c1c1b" r="50"></circle>
          <text text-anchor="middle" fill="white">{{ v.name }}</text>
        </g>
      </g>
    </svg>
  </div>
</div>
